import { useNavigate, useParams } from "react-router-dom";
import { ErrorBox } from "@idwal/idwal-react-components";
import { useTranslation } from "react-i18next";
import { INSPECTIONS_ROUTE } from "../config/router";
import { AUTH_URL_PROTOCOL } from "../cognito/authConfig";
import { useAuthenticator } from "@aws-amplify/ui-react";

export const ErrorPage = ({ status }: any) => {
    const { statusCode } = useParams(); // Get the status code from the URL parameter
    const { t } = useTranslation("locale");
    const navigate = useNavigate();
    const { authStatus } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);

    if (!status) {
        status = Number(statusCode);
    }

    const isLoggedOut = authStatus !== "authenticated";

    const onClickAction =
        status === 401
            ? () =>
                  window.location.assign(
                      `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}/logout?redirect=${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com`
                  )
            : () => navigate(`/${INSPECTIONS_ROUTE}`);

    return (
        <div
            style={{
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <ErrorBox
                statusCode={status}
                isLoggedOut={isLoggedOut}
                buttonLabel={t("errorPage.BackToReports")}
                onClickAction={onClickAction}
            />
        </div>
    );
};
